import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAngleRight,
  faBell,
  faFilter,
  faList,
  faCalendarAlt,
  faCog,
  faDollarSign,
  faSearchDollar,
  faSignOutAlt,
  faUser,
  faCode,
  faUsers,
  faAward,
  faImage,
  faBookOpen,
  faStethoscope,
  faAt,
  faBuilding,
  faMapMarkerAlt,
  faGlobe,
  faTimes,
  faFileAlt,
  faFileLines,
  faEdit,
  faTimesCircle,
  faCheckCircle,
  faComments,
  faCloud,
  faExternalLinkAlt,
  faProjectDiagram,
  faPenNib,
  faQuoteRight,
  faAsterisk,
  faSearch,
  faLeaf,
  faFingerprint,
  faCalculator,
  faFileUpload,
  faQuestion,
  faPhone,
  faCaretUp,
  faCaretDown,
  faPlus,
  faMinus,
  faBriefcase,
  faUserSecret,
  faQuestionCircle,
  faGlobeAmericas,
  faLayerGroup,
  faClock,
  faClockRotateLeft,
  faMapSigns,
  faPauseCircle,
  faTachometerAlt,
  faHistory,
  faExclamationCircle,
  faRocket,
  faCity,
  faFolderOpen,
  faPlay,
  faFlagUsa,
  faCheck,
  faExclamationTriangle,
  faEllipsisV,
  faEllipsis,
  faSackDollar,
  faHandHoldingDollar,
  faCircleInfo,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faDownload,
  faCopy,
  faMinusCircle,
  faMoneyCheckDollar,
  faHandshake,
  faRobot,
  faFlag,
  faTrash,
  faArrowRightArrowLeft,
  faMagnifyingGlass,
  faMagnifyingGlassChart,
  faMagnifyingGlassPlus,
  faCertificate,
  faRotate,
  faLocationDot,
  faMessage,
  faStore,
  faXmark,
  faArrowsRotate,
  faNetworkWired,
  faBarsProgress,
  faSignal,
  faCoins,
  faMicroscope,
  faGraduationCap,
  faSquarePlus,
  faQuoteLeft,
  faFileExcel,
  faLock,
  faCommenting,
  faThumbsUp,
  faThumbsDown,
  faEnvelope,
  faVideo,
  faThumbtack,
} from '@fortawesome/free-solid-svg-icons';

import {
  faCommenting as faCommentingRegular,
  faThumbsUp as faThumbsUpRegular,
  faThumbsDown as faThumbsDownRegular,
} from '@fortawesome/free-regular-svg-icons';

import {
  faLinkedin,
  faFacebookSquare,
  faGoogle,
  faSquareXTwitter,
  faInstagramSquare,
  faResearchgate,
  faSalesforce,
  faHubspot,
  faMicrosoft,
} from '@fortawesome/free-brands-svg-icons';

import AcademiaIcon from './AcademiaIcon';
import SparklesIcon from './SparklesIcon';

const icons = {
  accept: faCheckCircle,
  author: faPenNib,
  award: faAward,
  bell: faBell,
  book: faBookOpen,
  briefcase: faBriefcase,
  calculator: faCalculator,
  calendar: faCalendarAlt,
  cancel: faTimesCircle,
  caret: faAngleRight,
  category: faLayerGroup,
  certificate: faCertificate,
  chat: faComments,
  check: faCheck,
  chevronDown: faChevronDown,
  chevronUp: faChevronUp,
  chevronLeft: faChevronLeft,
  chevronRight: faChevronRight,
  circleInfo: faCircleInfo,
  citation: faQuoteRight,
  city: faCity,
  clock: faClock,
  clockRotateLeft: faClockRotateLeft,
  close: faXmark,
  code: faCode,
  coins: faCoins,
  commenting: faCommenting,
  commentingRegular: faCommentingRegular,
  company: faBuilding,
  copy: faCopy,
  crm: faCloud,
  delete: faTimes,
  dollar: faDollarSign,
  dollarNote: faMoneyCheckDollar,
  download: faDownload,
  edit: faEdit,
  email: faAt,
  envelope: faEnvelope,
  error: faExclamationCircle,
  facebook: faFacebookSquare,
  ellipsis: faEllipsis,
  fileLines: faFileLines,
  fileExcel: faFileExcel,
  filter: faFilter,
  fingerprint: faFingerprint,
  flag: faFlag,
  flagUsa: faFlagUsa,
  folderOpen: faFolderOpen,
  globe: faGlobe,
  google: faGoogle,
  graduationCap: faGraduationCap,
  handHoldingDollar: faHandHoldingDollar,
  handShake: faHandshake,
  help: faQuestion,
  history: faHistory,
  hubspot: faHubspot,
  microsoft: faMicrosoft,
  dynamics: faMicrosoft,
  image: faImage,
  impactScore: faTachometerAlt,
  instagram: faInstagramSquare,
  invalid: faTimesCircle,
  keywords: faSearch,
  link: faExternalLinkAlt,
  linkedin: faLinkedin,
  list: faList,
  locationDot: faLocationDot,
  lock: faLock,
  magnifyingGlass: faMagnifyingGlassChart,
  magnifyingGlassNormal: faMagnifyingGlass,
  magnifyingGlassPlus: faMagnifyingGlassPlus,
  map: faMapMarkerAlt,
  mapSigns: faMapSigns,
  mesh: faLeaf,
  message: faMessage,
  microscope: faMicroscope,
  minus: faMinus,
  network: faProjectDiagram,
  networkWired: faNetworkWired,
  options: faEllipsisV,
  pause: faPauseCircle,
  phone: faPhone,
  pin: faThumbtack,
  play: faPlay,
  plus: faPlus,
  private: faUserSecret,
  progress: faBarsProgress,
  public: faGlobeAmericas,
  quoteLeft: faQuoteLeft,
  reference: faAsterisk,
  refresh: faArrowsRotate,
  report: faFileAlt,
  researchgate: faResearchgate,
  rightArrowLeft: faArrowRightArrowLeft,
  robot: faRobot,
  rocket: faRocket,
  rotate: faRotate,
  sackDollar: faSackDollar,
  salesforce: faSalesforce,
  searchDollar: faSearchDollar,
  settings: faCog,
  shared: faUsers,
  signal: faSignal,
  signOut: faSignOutAlt,
  sortAsc: faCaretUp,
  sortDesc: faCaretDown,
  squarePlus: faSquarePlus,
  store: faStore,
  thumbsDown: faThumbsDown,
  thumbsDownRegular: faThumbsDownRegular,
  thumbsUp: faThumbsUp,
  thumbsUpRegular: faThumbsUpRegular,
  toBeValidated: faMinusCircle,
  trash: faTrash,
  activity: faStethoscope,
  trial: faStethoscope,
  twitter: faSquareXTwitter,
  unverified: faQuestionCircle,
  upload: faFileUpload,
  user: faUser,
  users: faUsers,
  valid: faCheckCircle,
  verified: faCheckCircle,
  video: faVideo,
  warning: faExclamationTriangle,
};

const RotatingIconWithProps = ({ up, children, ...rest }) => (
  <div {...rest}>{children}</div>
);

const RotatingIcon = styled(RotatingIconWithProps)`
  margin-left: 4px;
  align-self: flex-start;
  transform: ${p => (p.up ? 'rotate(180deg)' : 'rotate(0)')};
  transition: transform 0.2s linear;
`;

const Icon = ({
  color = 'white',
  icon,
  size = '2x',
  style,
  className,
  onClick,
  disabled,
  title,
  rotating = false,
  up,
  'data-testid': dataTestId = 'icon',
}) => {
  const customIcons = {
    academia: AcademiaIcon,
    sparkles: SparklesIcon,
  };

  if (customIcons[icon]) {
    const CustomIcon = customIcons[icon];
    return rotating ? (
      <RotatingIcon up={up}>
        <CustomIcon onClick={onClick} color={color} style={style} />
      </RotatingIcon>
    ) : (
      <CustomIcon onClick={onClick} color={color} style={style} />
    );
  } else {
    if (icon && icons[icon]) {
      return rotating ? (
        <RotatingIcon up={up}>
          <FontAwesomeIcon
            data-testid={dataTestId}
            icon={icons[icon]}
            size={size}
            color={disabled ? 'rgba(0,0,0,0.25)' : color}
            style={style}
            className={className}
            onClick={disabled ? null : onClick}
            title={title}
          />
        </RotatingIcon>
      ) : (
        <FontAwesomeIcon
          data-testid={dataTestId}
          icon={icons[icon]}
          size={size}
          color={disabled ? 'rgba(0,0,0,0.25)' : color}
          style={style}
          className={className}
          onClick={disabled ? null : onClick}
          title={title}
        />
      );
    } else {
      return <div></div>;
    }
  }
};

export default Icon;
